import React from "react";

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-8 rs-fade-up">
      <div>
        <p className="text-xs tracking-[0.25em] uppercase text-[#00F0FF] font-mono-rs mb-2">{subtitle}</p>
        <h1 className="font-mono-rs text-3xl sm:text-4xl font-bold tracking-tighter uppercase text-white">{title}</h1>
      </div>
      {children}
    </div>
  );
}

export function ModalityBadge({ modality }) {
  if (modality === "Both") {
    return (
      <span className="font-mono-rs text-[10px] tracking-widest uppercase px-2 py-0.5 border text-[#B15CFF] border-[#8A2BE2]/60 bg-[#8A2BE2]/10">
        CT + X-ray
      </span>
    );
  }
  if (modality === "CT/X-ray") {
    return (
      <span className="font-mono-rs text-[10px] tracking-widest uppercase px-2 py-0.5 border text-[#34E5B0] border-[#34E5B0]/50 bg-[#34E5B0]/10">
        CT / X-ray
      </span>
    );
  }
  const isCT = modality === "CT";
  return (
    <span
      className={`font-mono-rs text-[10px] tracking-widest uppercase px-2 py-0.5 border ${
        isCT ? "text-[#D902EE] border-[#D902EE]/50 bg-[#D902EE]/10" : "text-[#00F0FF] border-[#00F0FF]/50 bg-[#00F0FF]/10"
      }`}
    >
      {modality}
    </span>
  );
}

export function catColor(category) {
  if (category === "CT") return "#D902EE";
  if (category === "X-ray") return "#00F0FF";
  return "#8A2BE2";
}

export function modColor(modality) {
  if (modality === "CT") return "#D902EE";
  if (modality === "X-ray") return "#00F0FF";
  return "#34E5B0"; // CT/X-ray combined night coverage
}

export function StatusBadge({ status }) {
  const map = {
    pending: "text-[#FFB800] border-[#FFB800]/50 bg-[#FFB800]/10",
    approved: "text-[#00FF66] border-[#00FF66]/50 bg-[#00FF66]/10",
    denied: "text-[#FF003C] border-[#FF003C]/50 bg-[#FF003C]/10",
  };
  return (
    <span className={`font-mono-rs text-[10px] tracking-widest uppercase px-2 py-0.5 border ${map[status] || ""}`}>
      {status}
    </span>
  );
}
